import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createPortal } from "react-dom";
import logingImg from "assets/img/loginImage.jpg";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import useAuth from "hooks/use-auth";
import ImgContainer from "components/shared/Image";
import {
  ForgetPassWrapper,
  LeftGrid,
  RightGrid,
  StyledDivider,
  StyledForgetPassText,
  StyledInput,
  StyledTitle,
  StyledAppbarCM,
} from "./sendOtp.style";
import { loginOtpSchema } from "validations";
import { StyledLink } from "components/shared/Link";
import { sendOtpRequest, loginOtpRequest } from "api/requests";
import { useState } from "react";
import AppbarCM from "components/appbar";
import LoadingPartCM from "components/shared/PartLoading";
import InputAdornment from "@mui/material/InputAdornment";
import { BsPhone } from "react-icons/bs";
import { RiLockPasswordLine } from "react-icons/ri";
import {Helmet} from "react-helmet";

const arrayCode = [];

export default function SendOtp() {
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);
  const [phone, setPhone] = useState(0);
  const authCTX = useAuth();
  const { request, loading } = useHttp(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginOtpSchema),
  });

  const onSubmit = async (values) => {
    const transformedData = { phone_number: values.phone_number };
    let res = await request({
      url: sendOtpRequest,
      values: transformedData,
    });

    if (res) {
      setShowOtp(true);
    }
  };

  const onSubmitOtp = async () => {
    let res = await request({
      url: loginOtpRequest,
      values: {
        phone_number: phone,
        otp: arrayCode[arrayCode.length - 1].toString(),
      },
    });

    if (res) {
      if (res.full_name === null) {
        navigate("/name");
        authCTX.login(res.token);
      } else {
        authCTX.login(res.token);
      }
      setPhone("");
    }
  };

  const handleChange = (e) => {
    arrayCode.push(e.target.value.replace(/\s+/g, ""));
    console.log(arrayCode);
    if (arrayCode[arrayCode.length - 1].length == 6) {
      onSubmitOtp();
    }
  };

  return createPortal(
    <>
      {/* {loading && <LoadingCM />} */}
      <Helmet>
        <title>ورود / ثبت نام - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: "100vh" }}
      >
        <LeftGrid item sm={6} xs={6}>
          <ImgContainer
            src={logingImg}
            alt="لوگو"
            // objectFit="contain"
            width="auto"
            height="100%"
          />
        </LeftGrid>
        <RightGrid item lg={6} md={6} sm={6} xs={12}>
          <div>
            <StyledTitle variant="h4" alignSelf="center">
              ورود و ثبت نام
            </StyledTitle>
            {showOtp ? (
              <StyledInput
                id="phone_number"
                label="شماره تلفن :"
                fullWidth
                type="number"
                {...register("phone_number")}
                error={Boolean(errors["phone_number"])}
                helperText={errors["phone_number"]?.message}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <BsPhone />
                    </InputAdornment>
                  ),
                }}
                style={{ direction: "rtl" }}
              />
            ) : (
              <StyledInput
                id="phone_number"
                label="شماره تلفن"
                fullWidth
                type="number"
                {...register("phone_number")}
                error={Boolean(errors["phone_number"])}
                helperText={errors["phone_number"]?.message}
                style={{ direction: "rtl" }}
                onChange={(e) => setPhone(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BsPhone />
                    </InputAdornment>
                  ),
                }}
              />
            )}

            {showOtp ? (
              <StyledInput
                id="otp"
                label="کد پیامک شده"
                fullWidth
                type="number"
                {...register("otp")}
                error={Boolean(errors["otp"])}
                helperText={errors["otp"]?.message}
                style={{ textAlign: "right", direction: "rtl" }}
                InputProps={{
                  readOnly: loading ? true : false,
                  startAdornment: (
                    <InputAdornment position="start">
                      <RiLockPasswordLine />
                    </InputAdornment>
                  ),
                }}
                onInput={(e) => handleChange(e)}
              />
            ) : (
              ""
            )}

            {showOtp ? (
              <Button
                variant="contained"
                onClick={handleSubmit(onSubmitOtp)}
                fullWidth
                style={{ height: "45px" }}
                disabled={loading ? true : false}
              >
                {loading ? <LoadingPartCM /> : "ورود"}
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleSubmit(onSubmit)}
                fullWidth
                style={{ height: "40px" }}
                disabled={loading ? true : false}
              >
                {loading ? <LoadingPartCM /> : "دریافت کد"}
              </Button>
            )}

            <ForgetPassWrapper>
              <StyledDivider variant="middle">یا</StyledDivider>
              <StyledLink to="/loginColleague">
                <StyledForgetPassText>
                  آیا شما همکار هستید : ورود همکار
                </StyledForgetPassText>
              </StyledLink>
              {showOtp ? (
                " "
              ) : (
                <StyledLink to="/">
                  <StyledForgetPassText sx={{ marginTop: "10px" }}>
                    صفحه اصلی سایت
                  </StyledForgetPassText>
                </StyledLink>
              )}
            </ForgetPassWrapper>
          </div>
        </RightGrid>
        <StyledAppbarCM />
      </Grid>
    </>,
    document.getElementById("login")
  );
}
